import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { LoaderService } from '../loader.service';
import { CommonDataProvider } from './common.data-provider';
import { CompanyService } from '../company.service';
import { Addon, AddonGroup } from '../../models/addon.model';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class AddonsDataProvider extends CommonDataProvider<Addon> {
  private addonGroupsUrl = environment.apiUrl + '/admin/addon-groups';
  private addonCompanyGroupsUrl = environment.apiUrl + '/admin/companies';

  constructor(
    http: HttpClient,
    private companyService: CompanyService,
    loaderService: LoaderService
  ) {
    super(http, loaderService);
  }

  getAddonGroups = (): Observable<AddonGroup[]> =>
    this.http
      .get<
        AddonGroup[]
      >(`${this.addonCompanyGroupsUrl}/${this.companyService.COMPANY_ID}/addon-groups`)
      .pipe(
        map((items: AddonGroup[]) =>
          items.map(group => ({
            ...group,
            addon_group_items: group.addon_group_items.map(this.toViewAddon)
          }))
        ),
        catchError(this.handleError)
      );

  bulkSaveAddonGroups(groups: AddonGroup[]): Observable<AddonGroup[]> {
    const backendGroups = groups.map(this.fromViewAddonGroup);
    return this.http
      .put<
        AddonGroup[]
      >(`${this.addonCompanyGroupsUrl}/${this.companyService.COMPANY_ID}/addon-groups/bulk`, backendGroups)
      .pipe(
        map((updatedGroups: AddonGroup[]) => updatedGroups.map(this.toViewAddonGroup)),
        catchError(this.handleError)
      );
  }

  deleteAddonGroup = (id: number) =>
    this.http.delete(`${this.addonGroupsUrl}/${id}`).pipe(catchError(this.handleError));

  updateGroupOrder = (id: number, array: number[]) =>
    this.http
      .post(`${this.addonGroupsUrl}/order`, array, {
        params: { meal_id: id + '' }
      })
      .pipe(catchError(this.handleError));

  toViewAddonGroup = (data: AddonGroup): AddonGroup =>
    ({
      ...data,
      addon_group_items: data.addon_group_items.map(this.toViewAddon)
    }) as AddonGroup;

  fromViewAddonGroup = (data: AddonGroup): AddonGroup =>
    ({
      ...data,
      addon_group_items: data.addon_group_items.map(this.fromViewAddon)
    }) as AddonGroup;

  toViewAddon(data: Addon) {
    return {
      ...data,
      addon: {
        ...data.addon,
        price: data.addon.price / 100
      }
    };
  }

  fromViewAddon(data: Addon) {
    return {
      ...data,
      addon: {
        ...data.addon,
        price: data.addon.price * 100
      }
    };
  }
}
